import React, { useEffect, useState } from 'react';
import Deli_Logo from '../assets/Deli_Logo.svg';
import Button from '../components/Button';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useAuth0 } from '@auth0/auth0-react';
import { jwtDecode } from "jwt-decode";
import LoadingSpinner from '../components/LoadingSpinner';
import { updateUser, verifyCardOnFile } from '../utils/apiHandler';

const Step2 = () => {
  const navigate = useNavigate();
  const [mlsNumber, setNumber] = useState(null);
  const { getAccessTokenSilently, getIdTokenClaims,isAuthenticated, isLoading, getAccessTokenWithPopup, logout} = useAuth0();
  const [btnLoading , setBtnLoading] = useState(false);
  const [isTokenChecked, setIsTokenChecked] = useState(false);


  useEffect(() => {
  
    const authenticate = async ()=>{

      await getAccessTokenSilently({cacheMode: 'off'});


      const idTokenClaims = await getIdTokenClaims();
      const idToken = idTokenClaims.__raw;
 
      if(idToken)
      {
        const decodedToken = jwtDecode(idToken);
        if (decodedToken?.mls_active) {
          if (decodedToken?.broker_mls_id){
            var paymentPlan = localStorage.getItem("plan_type") ? localStorage.getItem("plan_type") : 'monthly';
            if(await verifyCardOnFile((await getIdTokenClaims()).__raw, paymentPlan))
              navigate("/chat");
          }else{
           navigate("/step3");
          }
        }
        setTimeout(() => {
          setIsTokenChecked(true);
        }, 2000);
      }
    }

    authenticate()
  },[getIdTokenClaims, isAuthenticated,getAccessTokenSilently,navigate])
 

  if (!isTokenChecked || isLoading) {
    return <LoadingSpinner />; // Show the loading spinner when not authenticated and loading
  }

  const NumberAuthentication = async () => {
    setBtnLoading(true);
    // Save MLS number to the API
    let body = {
      mls_id: mlsNumber,
    }
    const isSuccess = await updateUser(getIdTokenClaims, body, true, getAccessTokenWithPopup, logout);

    if (isSuccess) {
      toast.success(
        'We have verified your membership to utahrealestate.com MLS',
        {
          style: {
            fontSize: '12px', // Adjust the font size as needed
            width: '100%',
          },
          onClose: async () => {
            // Navigate to '/step3' when the toast is closed
            var paymentPlan = localStorage.getItem("plan_type") ? localStorage.getItem("plan_type") : 'monthly';
            if(await verifyCardOnFile((await getIdTokenClaims()).__raw, paymentPlan))
              navigate('/step3');
          },
        }
      );
    } else {
      toast.error(
        'Your MLS number cannot be verified to a member in Utahrealestate’s MLS.',
        {
          style: {
            fontSize: '12px', // Adjust the font size as needed
            width: '100%',
          },
          toastClassName: 'custom-toast',
        }
      );
      setBtnLoading(false);
    }
  };

  return (
    <div className="h-[95vh] overflow-h-scroll">
      <div className="flex justify-center items-center w-full py-12">
        <div className="">
          <div className="flex justify-center items-center">
            <img src={Deli_Logo} alt="" />
          </div>

          <div className="mt-12">
            <div className="sm:max-w-[60%] max-w-full sm:px-3 px-5  mx-auto flex items-center justify-center flex-col">
              <h1 className="text-black tracking-wider font-bold md:text-7xl leading-tight text-center sm:text-6xl text-5xl">
                Welcome
              </h1>
              <p className="text-[14px] font-semibold sm:py-3 py-4 text-center">
                What is your Utahrealestate.com member number?
              </p>
            </div>

            <div className="flex items-center gap-4 justify-center sm:py-0 py-3">
              <div className="w-20 h-1 bg-[#0062FF] rounded-full"></div>
              <div className="w-20 h-1 rounded-full">
                <div className="w-full h-full bg-[#0062FF] rounded-full fade-animation"></div>
              </div>
              <div className="w-20 h-1 border-2 rounded-full"></div>
            </div>
            <div className="md:max-w-[63%] max-w-full px-3 mx-auto">
              <div>
                {/* Input boxes */}
                <div className="max-w-full py-3 mt-4 px-4 rounded-full border-[#7E8799] border bg-[#ffff] ">
                  <input
                    onChange={(e) => setNumber(e.target.value)}
                    className="w-full outline-white border-none focus:outline-none focus:border-none"
                    type="text"
                    placeholder="Utahrealestate.com member number"
                    style={{ width: '100%' }}
                  />
                </div>
              </div>
              {/* Checkboxes */}
              <div>
                <div className="flex flex-col items-center gap-2 my-6 sm:my-4 text-sm">
                  <h1 className="font-bold text-md">Why do we ask this?</h1>
                  <p className="text-center">
                    Since we combine data with URE, our customers must be members to view specific listing content.
                  </p>
                </div>
              </div>
              {/* Button */}
              <div onClick={NumberAuthentication}>
                <Button
                  text={btnLoading ? "Loading ..." : "Continue"}
                  bgColor={btnLoading ? "bg-[#9199a7]" : "bg-[#0062ff]"}
                  textColor="text-white"
                  disabled={btnLoading}
                />
              </div>
              {/* Footer Box */}
              <div className="w-full bg-[#0062FF2B] shadow-xl border lg:mt-12 sm:mt-4 mt-6 py-4 rounded-lg">
                <h1 className="max-w-[90%] text-center mx-auto">
                  DELI makes it fun to search for a home and allows you to really personalize your requirements and wants for your home purchase.
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Step2;
